<template>
  <div :loading="loading" class="app-container">
    <div class="fixedButton">
      <vxe-button class="examineButton" @click="ReturnFun(0)">返回</vxe-button>
      <vxe-button status="primary" @click="submint()">保存</vxe-button>
    </div>
    <!-- 活动信息 -->
    <div class="CertificateReleaseApplicationBox" :style="`height:${$store.state.app.height - 80}px;`">
     <activityInformation :data="activity" :disabled="true" :special-budget="specialBudgetFlag" />
      <registerInformation
        ref="registerInformation"
        :data.sync="signData"
        :activity.sync="activity"
        :file-list.sync="fileList"
        :disabled-edit="!specialBudgetFlag"
        @setStrainsArr="setStrainsArr"
      />
      <!-- <clientTarget
        ref="clientTarget"
        :apply.sync="signData"
        :activity.sync="activity"
        :car-series-list.sync="carSeriesList"
        :sub-series.sync="SelectLists.subSeries"
      />  -->
      <!-- <div style="height: 100px; width: 100%; padding: 0px 40%">
        <vxe-button :loading.fullscreen.lock="fullscreenLoading" style="width: 250px; margin-top: 10px" type="primary" icon="el-icon-check" @click="submint('signUpForm')">提交</vxe-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { findDealerActById, saveApplyInfo, savePlanCustomers, uploadPlanFiles } from '@/api/actPlan'
// import { findDealerActById, savePlanCustomers, uploadPlanFiles } from '@/api/actPlan'
import activityInformation from './components/activityInformation'
import registerInformation from './components/registerInformation'
// import clientTarget from './components/clientTarget'

export default {
  name: 'SignActivity',
  components: {
    activityInformation,
    registerInformation,
    // clientTarget,
    // activityForm
  },
  data() {
    return {
      loading: false,
      fileList: [],
      fullscreenLoading: false,
      requipmentInfoCar: [],
      activity: {
        actId: null
      },
      signData: {
        id: null, // 提报活动id
        planId: null, // 活动计划id
        planDealerId: null, // 活动下发对象经销商id，不是经销商id
        actMonth: null, // 申报月份
        planApplyName: null, // 提报活动提报名
        applyTime: null, // 提报时间
        itemType: 1, // 提报类型
        planStartTime: null, // 提报活动计划开始时间
        planEndTime: null, // 提报活动计划结束时间
        executeNums: null, // 执行数量
        actBudget: null, // 活动预算
        strainsName: '', // 品系
        strainsCode: '', // 品系编码
        strainsNameList: [], // 品系列表
        strainsCodeList: [], // 品系编码列表
        strainsCodeNameMap: {}, // 主推品系编码及对应名称
        // strainsArr: [], // 品系编码数组
        applyStatus: null,
        regionId: null,
        regionName: null,
        zoneId: null,
        zoneName: null,
        budgetTypeCode: '',
        // invoicingNumber: null, // 开票数
      },
      SelectLists: {},
      strainsName: '',
      specialBudgetFlag: false, // 活动提报名称编辑
      carSeriesList: []
    }
  },
  created() {
    this.SelectListsFun()
    if (this.$route.params.id) {
      this.getActById(this.$route.params.id)
    }
    if (this.$route.params.type) {
      this.signData.itemType = this.$route.params.type
      this.signData.applyStatus = '0'
    }
  },
  methods: {
    // 提交车系集客目标
    saveCustomerInfo() {
      const data = {
        planApplyId: this.signData.id,
        customers: this.$refs.clientTarget.data.data
      }
      this.loading = true
      savePlanCustomers(data).then(res => {
        console.log("🚀 ~ savePlanCustomers ~ res:", res)
        if (res.code === 1) {
          console.log("🚀 ~ savePlanCustomers ~ res:", res)
          this.$message.success('保存成功')
          this.ReturnFun(1)
        } else {
          this.$message.error(res.message)
        }
          console.log("🚀 ~ savePlanCustomers ~ res:", res)
        this.loading = false
      })
    },
    // 新增提报数据
    addMarketactivity() {
      // this.signData.strainsCode = this.signData.strainsArr.toString()
      this.signData.budgetTypeCode = this.activity.budgetTypeCode
      this.loading = true
      const activityForm = this.$refs.registerInformation.$refs.activityForm.getActivityForm()
      const params = Object.assign(this.signData, activityForm)

      console.log(params,'----params00000');
      
      saveApplyInfo(params).then(res => {
        if (res.code === 1 && res.data) {
          this.signData = res.data
          // this.saveFile()
          // this.saveCustomerInfo()
          this.$message.success('保存成功')
          this.ReturnFun(1)
          this.loading = false
          //if (res.data.cort) {
          //  this.$message.warning('经销商剩余核销费用剩余不足10%')
          //}
        } else {
          this.loading = false
          this.$message.error(res.message)
        }
      })
    },
    saveFile() {
      if (this.fileList.length < 1) {
        return
      }
      const formData = new FormData()
      if (this.fileList) {
        this.fileList.forEach(val => {
          if (val.raw) {
            formData.append('file', val.raw)
          }
        })
      }
      const data = {
        type: 'actPlanApply',
        code: this.signData.planApplyCode
      }
      const param = JSON.stringify(data)
      formData.append('params', new Blob([param], { type: 'application/json' }))
      uploadPlanFiles(formData).then()
    },
   submint() {
      console.log("🚀 ~ submint ~ this.$refs.registerInformation:", this.$refs.registerInformation)
      this.$refs.registerInformation.$refs['signUpForm'].validate(async valid => {
        if (valid) {
          const res = await this.$refs.registerInformation.$refs.activityForm.$refs['ruleForm'].validate().catch((err)=>{return err})
          if (!res) {
            return  this.$message.error('请检查表单，完成所有必填项目！')
          }

          if (this.$refs.registerInformation.$refs.activityForm.vehicleModelAndQuantity.length === 0 &&
              this.$refs.registerInformation.$refs.activityForm.vehicleModelCheck === 1) {
            return this.$message.error('请选择主推车型及数量！')
          }

          // 校验合计大于0
          const activityForm = this.$refs.registerInformation.$refs.activityForm.getActivityForm()
          const totalCost = Number(activityForm.totalCost)
          if (!totalCost || totalCost <= 0) {
            this.$message.warning('您申请的核销金额为0，请重新填写后再提交。')
            return
          }

          // 调用保存
          this.addMarketactivity()
        } else {
          this.$message.error('请检查表单，完成所有必填项目！')
          return false
        }
      })
    },
    // 获取当期时间
    getNewDate() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      let H = date.getHours()
      let mm = date.getMinutes()
      let s = date.getSeconds()
      m = m < 10 ? '0' + m : m
      d = d < 10 ? '0' + d : d
      H = H < 10 ? '0' + H : H
      mm = mm < 10 ? '0' + mm : mm
      s = s < 10 ? '0' + s : s
      this.$set(this.signData, 'applyTime', y + '-' + m + '-' + d + ' ' + H + ':' + mm + ':' + s)
    },
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PeriodBudgetCode', 'subSeries']).then(v => {
        this.SelectLists = v
      })
    },
    // 获取活动详情
    getActById(id) {
      this.loading = true
      findDealerActById({ id: id }).then(res => {
        console.log("🚀 ~ findDealerActById ~ res:", res)
        if (res.code === 1 && res.data) {
          console.log("🚀 ~ findDealerActById ~ res:", res)
          console.log("🚀 ~ findDealerActById ~ res:", res)
          this.activity = res.data
          console.log("🚀 ~ findDealerActById ~ res:", res)
          this.signData.dealerName = this.activity.dealerName
          this.signData.dealerShortName = this.activity.dealerShortName
          this.signData.planId = this.activity.planId
          this.signData.planDealerId = this.activity.id
          this.signData.planApplyName = this.activity.actName
          this.signData.actBudget = this.activity.feeLimit
          this.handleSpecialBudget()
          this.getNewDate()
          this.getCarSeriesList()
        } else {
          this.$message.error(res.message)
        }
          console.log("🚀 ~ findDealerActById ~ res:", res)
        this.loading = false
      })
    },
    // 处理特殊预算类型（日常推广和新入网）
    handleSpecialBudget() {
      if (this.activity.budgetTypeCode === '1' || this.activity.budgetTypeCode === '13') {
        this.specialBudgetFlag = true
      }
    },
    getCarSeriesList() {
      if (this.activity.strainsCarCode) {
        this.carSeriesList = this.activity.strainsCarCode.split(',')
      }
    },
    ReturnFun(val) {
      console.log("🚀 ~ ReturnFun ~ val:", val)
      this.$closePage('/terminalActivity/signActivity', '/terminalActivity/applyActivityList')
      // if (val === 0) {
      //   this.$closePage('/terminalActivity/signActivity', '/terminalActivity/applyActivityList')
      // } else {
      //   this.$closePage('/terminalActivity/signActivity', '/terminalActivity/editSignActivity/' + this.signData.id)
      // }
    },
    setStrainsArr(val) {
      console.log(val);
      // this.signData.strainsArr = val
    },
    // 计算集客目标和订单目标是否等于下发的目标
    // countTarget(value) {
    //   const customerList = this.$refs.clientTarsaveCustomerInfoget.data.data
    //   if (value === 0) {
    //     // 使用 reduce 方法计算属性的总和
    //     const customerSum = customerList.reduce(function(accumulator, current) {
    //       return accumulator + Number(current.customerTarget)
    //     }, 0)
    //     return this.activity.customerTarget === customerSum
    //   } else {
    //     const orderSum = customerList.reduce(function(accumulator, current) {
    //       return accumulator + Number(current.orderTarget)
    //     }, 0)
    //     return this.activity.orderTarget === orderSum
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
.fixedButton {
  margin: 0 0 5px 0;
  border-bottom: 1px solid rgb(201, 201, 201);
  .examineButton {
    margin: 5px;
  }
}

.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  // padding: 0 5px;
  .elcolSpan {
    font-size: 12px;
    color: #606266;
    text-align: center;
  }
  .budgetBox {
    margin: 0 0 5px 0;
  }
}
.el-input.is-disabled .el-input__inner {
  color: #6a6a6a;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #6a6a6a;
}
.signActivity {
  padding: 10px 30px;
}
.item-line {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  // margin-left: 1%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.act-item {
  width: 300px;
  text-align: right;
  margin-bottom: 5px;
}
.sign-tiem {
  width: 300px;
  text-align: right;
}
.usereq {
  .el-row {
    margin: 5px 0 !important;
  }
  .grid-content,
  .grid-Prohibit {
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
    min-height: 36px;
  }
  .grid-content .el-checkbox__label {
    font-size: 16px;
  }
  .left_content {
    height: 80%;
    padding: 0 10px 10px 10px;
    overflow-y: auto;
    border-radius: 5px;
  }
  .center_content {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .el-select.el-input--small .el-input__inner {
    color: #616b80;
    width: 100%;
    background: #152841;
    border-color: #152841;
    border-radius: 5px;
  }
  .el-checkbox-group .el-checkbox__label {
    display: none;
  }
  .center {
    text-align: center;
  }
  .center_content_r {
    width: 90%;
    height: 200px;
    margin-top: 20px;
  }
  .rule_btn {
    width: 100%;
    height: 60px;
    background: #28548e;
    float: left;
    border: none;
  }
  .rule_btn_left,
  .rule_btn_right {
    background: #1074f6;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
  }
  .rule_btn_left img {
    transform: rotate(180deg);
  }
  .rule_btn_left:hover,
  .rule_btn_right:hover {
    background: #1e3a5f;
  }
}
</style>
